//TODO refactor this component - check if this is still needed

import React from 'react'
import styled from 'styled-components'
//import translate from '../../../../../../modules/translate'
//import AdidasLogo from '../../../../dummy-files/adidas.jpg'

const Wrapper = styled.div`
  display: flex;
  background-color: ${props => props.theme.color.multimedia.backgroundSecondary};
`
/*
const PoweredBy = styled.div`
  font-family: ${props => props.theme.font.primary};
  font-size: ${props => props.theme.fontSize.small};
  @media (max-width: ${props => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${props => props.theme.tablet.fontSize.small};
  }
  @media (max-width: ${props => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${props => props.theme.mobile.fontSize.small};
  }
  color: white;
  padding-right: ${props => (props.flexDirection !== 'column' ? '15px' : '0')};
  padding-bottom: ${props => (props.flexDirection === 'row' ? '0' : '5px')};
  min-width: 100px;
  text-align: center;
`


const AdidasImage = styled.img`
  height: 65px;
  padding: 5px 37px 5px 37px;
  background-color: #fff;
`
*/
const PoweredByAdidas = ({ flexDirection, alignItems, ...props }) => {
  return (
    <Wrapper {...props} flexDirection={flexDirection} alignItems={alignItems}>
      {/*
        <PoweredBy>{translate('poweredby')}</PoweredBy>
      <AdidasImage id="powered_by_ontour" src={AdidasLogo} />
        */}
    </Wrapper>
  )
}

PoweredByAdidas.defaultProps = {
  alignItems: 'center',
}

export default PoweredByAdidas
export { Wrapper as Wrapper0PoweredByAdidas }
